import {Box, HBox} from '@buncha/components/core/view';

import {CustomImage} from '@buncha/components/core/Image';
import ExtraItemCount from '../ExtraItemCount';
import If from '@buncha/components/conditional/If';
import React from 'react';
import {styles} from './styles';

interface ImageStackProps {
  imageUrls: string[];
}

const ImageStack: React.FC<ImageStackProps> = props => {
  const spiltData = props?.imageUrls?.slice(0, 3);
  const remainingCount =
    (props?.imageUrls?.length ?? 0) - (spiltData?.length ?? 0);

  return (
    <HBox>
      {spiltData?.map(url => (
        <CustomImage style={styles.imageStyle} source={url} />
      ))}
      <If condition={remainingCount}>
        <Box style={styles.container}>
          <ExtraItemCount
            count={(props?.imageUrls?.length ?? 0) - (spiltData?.length ?? 0)}
          />
        </Box>
      </If>
    </HBox>
  );
};

export default React.memo(ImageStack);
